<div mat-dialog-content>
    <mat-card class="cardborder">
        <mat-toolbar class="toobar">
            <mat-card-header class="toobarHeader">
                <mat-card-title 
                #weekEventDetailsDialogMenuTitle 
                contenteditable="true"
                (input)="editorTitleChange()"
                class="toolbarHeaderTitle"
                >{{ data.title }}
            </mat-card-title>
                <mat-card-subtitle class="toolbarHeaderText">{{ data.date }}</mat-card-subtitle>
            </mat-card-header>
            <span class="spacer"></span>
            <button mat-icon-button
            (click)="deleteEvent()">
                <mat-icon>delete_outline</mat-icon>
            </button>
            <button mat-icon-button>
                <mat-icon>bookmark_border</mat-icon>
            </button>
            <button mat-icon-button>
                <mat-icon>favorite_border</mat-icon>
            </button>
            <button mat-icon-button
            [mat-dialog-close]="getUpdatedWeekEventData()"
            ><mat-icon>last_page</mat-icon></button>
        </mat-toolbar>
        <ckeditor 
        [editor]="editor"
        [(ngModel)]="data.description" 
        [config]="editorConfig"
        (change)="editorContentChange($event)"
        ></ckeditor>
    </mat-card>
</div>